import React, { lazy, Suspense } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
  useLocation,
} from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
// import { PUBLIC_ROUTE } from "./route.constants";
import Loader from "../src/component/loader";

const SignIn = lazy(() => import("./pages/SignIn/SignIn"));
const SignUp = lazy(() => import("./pages/SignUp/SignUp"));
const ForgotPassword = lazy(() =>
  import("./pages/ForgotPassword/ForgotPassword")
);
const NotFound = lazy(() => import("./pages/404/404"));
const InternalServerError = lazy(() => import("./pages/500/500"));
const Waiting = lazy(() => import("./pages/Waiting/Waiting"));

const Layout = lazy(() => import("./pages/Layout/Layout"));

function PrivateRoute({ element }) {
  const isLoggedIn = localStorage.getItem("id_token");
  const location = useLocation();

  return isLoggedIn ? (
    element
  ) : (
    <Navigate to="/signin" state={{ from: location }} />
  );
}

export default function AppRoutes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Routes>
            <Route exact path="/signin" element={<SignIn />} />
            <Route exact path="/signup" element={<SignUp />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
            <Route exact path="/404" element={<NotFound />} />
            <Route exact path="/500" element={<InternalServerError />} />

            <Route exact path="/" element={<Navigate to={"/orders"} />} />
            <Route
              path="/orders"
              element={<PrivateRoute element={<Layout />} />}
            />
            <Route path="waiting" element={<Waiting />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
